import {Avatar, Grid, useMediaQuery, useTheme} from '@mui/material';

import {MatchLevel} from '../MatchLevel';

import {MiniCultureType} from './CultureFitHeader';
import {CultureTypeCard} from '../../../../../../components/CultureTypeCard/CultureTypeCard';
import {applicantMatchText} from '../../../../../../lib/constants';
import {extractPercentAsNumber} from '../../../../../../utils/extractPercentAsNumber';

interface Props {
  companyLogoUrl: string;
  companyCultureType: MiniCultureType;
  applicantAvatarUrl: string;
  applicantCultureType: MiniCultureType | null;
  culturalFitScore: string;
}

const AVATAR_OVERLAY_OFFSET = 20;

export const MobileDisplay = ({
  companyCultureType,
  applicantCultureType,
  culturalFitScore,
  companyLogoUrl,
  applicantAvatarUrl,
}: Props) => {
  const theme = useTheme();
  const isXsmall = useMediaQuery(theme.breakpoints.down(450));

  return (
    <Grid container justifyContent='center'>
      <Grid container item xs={12} sm={8} justifyContent={'space-between'} minWidth={isXsmall ? '100%' : '400px'}>
        <Grid container justifyContent='flex-start' alignContent='stretch' item xs={6} sm={4}>
          <Grid>
            <Grid container item alignItems='center' flexDirection='column'>
              <CultureTypeCard
                imageSize={'80px'}
                sx={{width: '175px'}}
                shouldDisplayEmpionLogo={false}
                name={companyCultureType.name}
                url={companyCultureType.url}
                typographyVariant='h5'
                isTransparentBackground={isXsmall}
                isXSmall={isXsmall}
              />
              <Avatar
                src={companyLogoUrl}
                variant='square'
                sx={{width: '40px', height: '40px', top: -AVATAR_OVERLAY_OFFSET}}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container item justifyContent='flex-end' xs={6} sm={4}>
          <Grid>
            <Grid container item alignItems='center' flexDirection='column'>
              <CultureTypeCard
                imageSize={'80px'}
                sx={{width: '175px'}}
                shouldDisplayEmpionLogo={false}
                name={applicantCultureType?.name}
                url={applicantCultureType?.url}
                typographyVariant='h5'
                isTransparentBackground={isXsmall}
                isMobile
                isXSmall={isXsmall}
              />
              <Avatar
                src={applicantAvatarUrl}
                variant='square'
                sx={{width: '40px', height: '40px', top: -AVATAR_OVERLAY_OFFSET}}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item sx={{top: -55, position: 'relative'}} sm={8}>
        <MatchLevel
          percent={extractPercentAsNumber(culturalFitScore)}
          isCultureTypeMissing={!applicantCultureType}
          matchText={applicantMatchText}
        />
      </Grid>
    </Grid>
  );
};
